import { render, staticRenderFns } from "./Anomalies.vue?vue&type=template&id=05a511c9"
import script from "./Anomalies.vue?vue&type=script&lang=js"
export * from "./Anomalies.vue?vue&type=script&lang=js"
import style0 from "./Anomalies.vue?vue&type=style&index=0&id=05a511c9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports